<template>
  <PlanCard>
    <PlanContent id="planContent">
      <template #title>
        <img
          :src="canvaLogo"
          alt="canva logo"
          class="w-full"
          style="height: 2rem !important; width: auto !important; margin-left: 0; margin-right: auto; display: block"
        />
      </template>
      <template #subtitle>
        <div class="w-full mt-2">
          {{ I18n.t("canva_value_props.same_bg_remover") }}
        </div>
      </template>

      <template #action>
        <Button
          full-width
          :aria-label="buttonText"
          as="link"
          href="https://canva.com/features/background-remover?utm_source=RBG_website&utm_medium=removebg&utm_content=RBG_pricing_page"
          target="_blank"
          style="background-color: #8b3dff !important"
          @click.native="() => rbgContentPageLinkClickedV100({ identifier: 'pricing-page-canva-link' })"
        >
          <div id="tryCanvaButton">
            <span>
              {{ buttonText }}
            </span>
            <svg style="align-self:center" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path
                fill-rule="evenodd"
                d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
              />
              <path
                fill-rule="evenodd"
                d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
              />
            </svg>
          </div>
        </Button>
        <span
          class="text-typo-tertiary block text-2xs !mt-2 billing-appendix w-full text-center px-2 truncate"
          id="leonardoAnchor"
          v-html="I18n.t('canva_value_props.leonardo_api', { link: 'https://leonardo.ai/news/removebg-api-leonardo?utm_source=RBG_website&utm_medium=removebg&utm_content=RBG_pricing_page'})"
          @click="onLeonardoLinkClick"
        >
        </span>
      </template>

      <template #plan-description>
        <slot name="plan-description" />
        <ul id="valueProps">
          <li style="font-weight: 500">
            {{ I18n.t("canva_value_props.ai_powered_social_posts") }}
          </li>
          <li v-if="Flipper.isEnabled('show_canva_bulk_info')">
            {{ I18n.t("canva_value_props.bulk_bg_removal") }}
          </li>
          <li>
            {{ I18n.t("canva_value_props.image_upscaler") }}
          </li>
          <li>
            {{ I18n.t("canva_value_props.distraction_removal") }}
          </li>
          <li>
            {{ I18n.t("canva_value_props.bg_generation") }}
          </li>
          <li>
            {{ I18n.t("canva_value_props.templates") }}
          </li>
        </ul>
      </template>
    </PlanContent>
    <Video :src="canvaProPlanVideo" id="canvaProVideo" class="rounded-4xl" />
  </PlanCard>
</template>

<script setup lang="ts">
import { Button, Video  } from "prism";
import PlanCard from "./plan_card.vue";
import PlanContent from "./plan_content.vue";
import { inject } from "vue";
import type { I18n as I18nType } from "i18n-js";
import canvaProPlanVideo from "@assets/videos/canva_pro_plan.mp4";
import canvaLogo from "@assets/images/canva_logo.svg";
import Flipper from "@/modules/flipper";
import { rbgContentPageLinkClickedV100 } from "kaleido-event-tracker";

const props = defineProps<{}>();

const I18n: I18nType = inject("I18n");

const buttonText = I18n.t("canva_value_props.try_canva");

const onLeonardoLinkClick = (event: MouseEvent) => {
  const anchor = (event.target as HTMLElement).closest("a");
  if (!anchor) return;

  // Open in a new tab (rather than relying on a translated target="_blank" attribute)
  // so this page never unloads and the tracking request always completes.
  event.preventDefault();
  rbgContentPageLinkClickedV100({ identifier: "pricing-page-leonardo-link" });
  window.open(anchor.href, "_blank");
};
</script>
<style lang="css">
#tryCanvaButton {
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: auto auto;
  gap: 0.5rem;
}

#canvaProVideo {
  object-fit: cover;
  height: 100% !important;
  width: 100%;

  @media (max-width: 992px) {
    max-height: 60vh;
  }

  @media (max-width: 550px) {
    grid-template-columns: 1fr;
    max-height: 320px;
    width: auto;
    margin: 0 auto;
  }
}

#planContent {
  height: 100%;
  justify-content: start;
  padding: 1rem;
}

#leonardoAnchor a {
  color: #454545 !important;
}

#valueProps li {
  margin-top: 0.5rem;
}
</style>
